import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';
import LocalizableSelect from 'PMT/components/form/LocalizableSelect';
import SecurityContext from 'utils/permissions/SecurityContext';

export default class StoreStateChooser extends Component {

  static defaultProps = {
    readOnly: false
  };

  static propTypes = {
    value: PropTypes.string.isRequired,

    // param: String, the chosen POS
    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool,

    disabled: PropTypes.bool,
  };

  onSelect = (option) => {
    // verify has permissions to choose ARCHIVED status
    if (!SecurityContext.proAccount.canArchiveRestaurant() && option.value === 'ARCHIVED') {
      return;
    }
    // verify has permissions to choose CREATED status.
    if (!SecurityContext.admin.isAdmin() && option.value === 'CREATED') {
      return;
    }
    if (_.isNull(option)) {
      this.props.onChange(null);
    } else {
      this.props.onChange(option.value)
    }
  };

  render() {
    const choices = [
      {
        label: I18n.tr('restaurant_edit.configuration.status.CREATED'),
        value: 'CREATED'
      },
      {
        label: I18n.tr('restaurant_edit.configuration.status.ENABLED'),
        value: 'ENABLED'
      },
      {
        label: I18n.tr('restaurant_edit.configuration.status.DISABLED'),
        value: 'DISABLED'
      },
      SecurityContext.proAccount.canArchiveRestaurant() && {
        label: I18n.tr('restaurant_edit.configuration.status.ARCHIVED'),
        value: 'ARCHIVED'
      },
    ].filter(Boolean)

    return (
      <div className="pos_chooser">
        <LocalizableSelect
          name="action"
          value={this.props.value}
          options={choices}
          onChange={this.onSelect}
          disabled={this.props.disabled}
          clearable
          placeholder={I18n.tr('restaurant_edit.configuration.status')}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }

}
